/**
 * Смесь двух цветов вида 0xRRGGBB (как их принимает Phaser): `share` — доля
 * второго цвета, от 0 (только первый) до 1 (только второй). Каналы
 * смешиваются линейно и округляются до целого
 * @param {number} color0x
 * @param {number} targetColor0x
 * @param {number} share
 * @returns {number}
 */
export const mixColor0x = (color0x, targetColor0x, share) => {
  const mixChannel = (shift) => {
    const from = (color0x >> shift) & 0xff;
    const to = (targetColor0x >> shift) & 0xff;
    return Math.round(from + (to - from) * share) << shift;
  };
  return mixChannel(16) | mixChannel(8) | mixChannel(0);
};
